import { useRouter, useSearch } from "@tanstack/react-router";
import omit from "lodash/omit";
import { Route } from "@/routes/__root";
import { BulkUploadLeadDialog } from "@crm/components/clients/bulk-upload-lead-dialog";
import { ClientOnboardingDialog } from "./client-onboarding";
import { CreateFamilyDialog } from "../families/create-family-dialog";
import { ClientLeadDialog } from "./add-client-dialog";

export function Dialogs() {
  const router = useRouter();
  const search = useSearch({
    from: Route.id,
  });

  const isOnboardingDialogOpen = search.modal === "onboarding";
  const isBulkUploadClientsOpen = search.modal === "bulk-upload-clients";
  const isCreateFamilyOpen = search.modal === "create-family";
  const isModifyFamilyOpen = search.modal === "modify-family";
  const isAddClientModalOpen = search?.modal === "client-lead";

  const closeBulkUploadClientsDialog = (open: boolean) => {
    if (open) {
      return;
    }
    if (router.history.canGoBack()) {
      router.history.back();
    } else {
      router.navigate({
        to: ".",
        search: (prev) => omit(prev, ["modal"]),
        replace: true,
      });
    }
  };

  if (isOnboardingDialogOpen) return <ClientOnboardingDialog />;

  if (isAddClientModalOpen) return <ClientLeadDialog />;

  if (isBulkUploadClientsOpen)
    return (
      <BulkUploadLeadDialog open onOpenChange={closeBulkUploadClientsDialog} />
    );

  if (isCreateFamilyOpen || isModifyFamilyOpen) return <CreateFamilyDialog />;

  return null;
}
